
var ROOT_SELECTOR = '[data-underline]';
var TEXT_SELECTOR = '[data-underline-text]';
var SWEEP_MS = 400;      
var LINE_TOLERANCE = 6; 

function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

// Measure the visible line boxes of `textEl`, relative to `host`. Lines clipped
// by -webkit-line-clamp are skipped so timing matches what's on screen.
function measureLines(textEl, host) {
    var range = document.createRange();
    range.selectNodeContents(textEl);
    var rects = range.getClientRects();
    var hostRect = host.getBoundingClientRect();
    var fontSize = parseFloat(window.getComputedStyle(textEl).fontSize) || 0;
    var maxBottom = hostRect.top + host.clientHeight + 1;
    var lines = [];

    for (var i = 0; i < rects.length; i++) {
        var rect = rects[i];
        if (!rect.width || !rect.height) continue;
        if (rect.top >= maxBottom) continue;                 // clipped by line-clamp
        var line = null;
        for (var j = 0; j < lines.length; j++) {
            if (Math.abs(lines[j].top - rect.top) <= LINE_TOLERANCE) { line = lines[j]; break; }
        }
        if (line) {
            line.left = Math.min(line.left, rect.left);
            line.right = Math.max(line.right, rect.right);
            line.bottom = Math.max(line.bottom, rect.bottom);
        } else {
            lines.push({ top: rect.top, left: rect.left, right: rect.right, bottom: rect.bottom });
        }
    }

    return lines.map(function (l) {
        var lineHeight = l.bottom - l.top;
        var glyphBottom = l.bottom - Math.max(0, (lineHeight - fontSize) / 2);
        return { x: l.left - hostRect.left, y: glyphBottom - hostRect.top + 1, w: l.right - l.left };
    });
}

function Underline(root) {
    this.root = root;
    this.textEl = root.querySelector(TEXT_SELECTOR);
    this.host = this.textEl.parentElement;
    this.bars = [];
    this.timings = [];
    this.removeTimer = null;
    this.host.classList.add('js-underline-host');

    var self = this;
    this.onEnter = function () { self.draw(); };
    this.onLeave = function () { self.erase(); };
    this.root.addEventListener('mouseenter', this.onEnter);
    this.root.addEventListener('mouseleave', this.onLeave);
    this.root.addEventListener('focusin', this.onEnter);
    this.root.addEventListener('focusout', this.onLeave);
}

Underline.prototype.clearBars = function () {
    for (var i = 0; i < this.bars.length; i++) {
        if (this.bars[i].parentNode) this.bars[i].parentNode.removeChild(this.bars[i]);
    }
    this.bars = [];
};

Underline.prototype.draw = function () {
    if (this.removeTimer) { clearTimeout(this.removeTimer); this.removeTimer = null; }
    this.clearBars();

    var lines = measureLines(this.textEl, this.host);
    if (!lines.length) return;

    var totalW = 0, i;
    for (i = 0; i < lines.length; i++) totalW += lines[i].w;
    if (totalW <= 0) return;


    this.timings = [];
    var before = 0;
    for (i = 0; i < lines.length; i++) {
        var dur = lines[i].w / totalW * SWEEP_MS;
        this.timings.push({ dur: dur, before: before, after: 0 });
        before += dur;
    }
    var acc = 0;
    for (i = lines.length - 1; i >= 0; i--) {
        this.timings[i].after = acc;
        acc += this.timings[i].dur;
    }

    for (i = 0; i < lines.length; i++) {
        var bar = document.createElement('span');
        bar.className = 'js-underline-bar';
        bar.setAttribute('aria-hidden', 'true');
        bar.style.left = lines[i].x + 'px';
        bar.style.top = lines[i].y + 'px';
        bar.style.width = lines[i].w + 'px';
        bar.style.transition = 'none';
        bar.style.transform = 'scaleX(0)';
        this.host.appendChild(bar);
        this.bars.push(bar);
    }

    var bars = this.bars, timings = this.timings;

    if (prefersReducedMotion()) { 
        for (var r = 0; r < bars.length; r++) bars[r].style.transform = 'scaleX(1)';
        return;
    }

    // Two frames so the scaleX(0) start state is committed before transitioning.
    requestAnimationFrame(function () {
        requestAnimationFrame(function () {
            for (var k = 0; k < bars.length; k++) {
                bars[k].style.transition = 'transform ' + timings[k].dur + 'ms linear ' + timings[k].before + 'ms';
                bars[k].style.transform = 'scaleX(1)';
            }
        });
    });
};

Underline.prototype.erase = function () {
    if (!this.bars.length) return;

    if (prefersReducedMotion()) {
        this.clearBars();
        return;
    }

    var bars = this.bars, timings = this.timings, total = 0;
    for (var k = 0; k < bars.length; k++) {
        bars[k].style.transition = 'transform ' + timings[k].dur + 'ms linear ' + timings[k].after + 'ms';
        bars[k].style.transform = 'scaleX(0)';
        var t = timings[k].dur + timings[k].after;
        if (t > total) total = t;
    }
    var self = this;
    this.removeTimer = setTimeout(function () { self.clearBars(); self.removeTimer = null; }, total + 50);
};

function init() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) {
        if (roots[i].querySelector(TEXT_SELECTOR)) new Underline(roots[i]);
    }
}

module.exports = { init: init };
